/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentPeople200,
  GetApiV1IndividualpaymentPeople401,
  GetApiV1IndividualpaymentPeople500,
  GetApiV1IndividualpaymentPeopleQueryParams,
  GetApiV1IndividualpaymentPeopleQueryResponse,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeople.ts";
import { ePaymentMethodSchema } from "../ePaymentMethodSchema.ts";
import { individualPaymentPersonViewModelSchema } from "../individualPaymentPersonViewModelSchema.ts";

export const getApiV1IndividualpaymentPeopleQueryParamsSchema = z
  .object({
    PersonIds: z.optional(z.array(z.coerce.number().int())),
    StudentName: z.optional(z.string()),
    Email: z.optional(z.string()),
    Ra: z.optional(z.string()),
    Cpf: z.optional(z.string()),
    ThirdPartyCpf: z.optional(z.string()),
    ThirdPartyCnpj: z.optional(z.string()),
    OurNumber: z.optional(z.string()),
    InvoiceNumber: z.optional(z.string()),
    ClassStudentId: z.optional(z.coerce.number().int()),
    CompanyId: z.optional(z.coerce.number().int()),
    PaymentMethod: z.optional(
      z
        .lazy(() => ePaymentMethodSchema)
        .describe(
          "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
        ),
    ),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1IndividualpaymentPeopleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentPeople200Schema = z.array(
  z.lazy(() => individualPaymentPersonViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentPeople200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentPeople401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentPeople500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentPeople500>;

export const getApiV1IndividualpaymentPeopleQueryResponseSchema = z.lazy(
  () => getApiV1IndividualpaymentPeople200Schema,
) as unknown as ToZod<GetApiV1IndividualpaymentPeopleQueryResponse>;
